import React, {useEffect, useState, useRef} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from "react-redux"
import debounce from 'lodash/debounce'
import {useParams} from 'react-router-dom';
import { GetAllCategory, addToCart, getCartItems } from "../action";
import logonew from '../assets/images/logo.svg';
import { GenderData } from '../action';
import axios from "../helper/axios";
import WomenSecretLogo from "../assets/brandLogo/Women_Secret-01.png"
import TimberlandLogo from "../assets/brandLogo/Timberland-01.png"
import GEXOLogo from "../assets/brandLogo/GEXO-01.png"
import SpringfieldLogo from "../assets/brandLogo/Springfield-01.png"
import MANGOLogo from "../assets/brandLogo/MANGO-01.png"
import CalvinKleinJeansLogo from "../assets/brandLogo/CalvinKleinJeans.png"
import CalvinKleinUnderwearLogo from "../assets/brandLogo/CalvinKleinUnderwear.png"
import HUGOLogo from "../assets/brandLogo/HUGO-01.png"
import ReplayLogo from "../assets/brandLogo/Replay-01.png"
import GuessLogo from "../assets/brandLogo/Guess-01.png"
import CarpisaLogo from "../assets/brandLogo/Carpisa-01.png"
import OliverLogo from "../assets/brandLogo/Oliver-01.png"
import XYZLogo from "../assets/brandLogo/XYZ-01.png"
import OrsayLogo from "../assets/brandLogo/Orsay-01.png"
import YamamayLogo from "../assets/brandLogo/Yamamay-01.png"
import Tom_TailorLogo from "../assets/brandLogo/Tom_Tailor-01.png"
import CelioLogo from "../assets/brandLogo/Celio-01.png"
import OkaidiLogo from "../assets/brandLogo/Okaidi-01.png"
import OzdilekLogo from "../assets/brandLogo/Ozdilek-01.png"
import BOSSLogo from "../assets/brandLogo/BOSS-01.png"

import SearchBox from './Common/SearchBox';

const logos = [
    {src: HUGOLogo, alt: "Hugo", link: '/brands/hugo'},
    {src: BOSSLogo, alt: "Boss Black", link: '/brands/boss'},
    {src: MANGOLogo, alt: "Mango", link: '/brands/mango'},
    {src: GuessLogo, alt: "Guess", link: '/brands/guess'},
    {src: OkaidiLogo, alt: "Okaidi", link: '/brands/okaidi'},
    {src: TimberlandLogo, alt: "Timberland", link: '/brands/timberland'},
    {src: ReplayLogo, alt: "Replay", link: '/brands/replay'},
    {src: OrsayLogo, alt: "Orsay", link: '/brands/orsay'},
    {src: GEXOLogo, alt: "Geox", link: '/brands/geox'},
    {src: SpringfieldLogo, alt: "Springfield", link: '/brands/springfield'},
    {src: CelioLogo, alt: "Celio", link: '/brands/celio'},
    {src: OliverLogo, alt: "Oliver Weber", link: '/brands/oliver-weber'},
    {src: OzdilekLogo, alt: "Ozdilek", link: '/brands/ozdilek'},
    {src: Tom_TailorLogo, alt: "Tom Tailor", link: '/brands/tom-tailor'},
    {src: CarpisaLogo, alt: "Carpisa", link: '/brands/carpisa'},
    {src: WomenSecretLogo, alt: "Women'secret", link: '/brands/womensecret'},
    {src: CalvinKleinJeansLogo, alt: "Calvin Klein Jeans", link: '/brands/calvin-klein-jeans'},
    {src: CalvinKleinUnderwearLogo, alt: "Calvin Klein Underwear", link: '/brands/calvin-klein-underwear'},
    {src: YamamayLogo, alt: "Yamamay", link: '/brands/yamamay'},
];

const femaleBrandData1 = [{img: WomenSecretLogo, brand: "WOMEN SECRET", status: ""},
    {img: TimberlandLogo, brand: "TIMBERLAND", status: ""},
    {img: GEXOLogo, brand: "GEOX", status: ""},
    {img: SpringfieldLogo, brand: "SPRINGFIELD", status: ""},
    {img: MANGOLogo, brand: "MANGO", status: ""},
    {img: CalvinKleinJeansLogo, brand: "CALVIN KLEIN JEANS", status: ""},
    {img: CalvinKleinUnderwearLogo, brand: "CALVIN KLEIN UNDERWEAR", status: ""},
    {img: HUGOLogo, brand: "HUGO", status: ""},
    {img: ReplayLogo, brand: "REPLAY", status: ""},
    {img: GuessLogo, brand: "GUESS", status: "Coming soon"},
    {img: CarpisaLogo, brand: "CARPISA", status: "Coming soon"},
    {img: OliverLogo, brand: "OLIVER WEBER", status: "Coming soon"},
    {img: XYZLogo, brand: "XYZ", status: "Coming soon"},
    {img: OrsayLogo, brand: "ORSAY", status: "Coming soon"},
    {img: YamamayLogo, brand: "YAMAMAY", status: "Coming soon"},
    {img: Tom_TailorLogo, brand: "TOM TAILOR", status: "Coming soon"}]

const maleBrandData1 = [{img: TimberlandLogo, brand: "TIMBERLAND", status: ""},
    {img: GEXOLogo, brand: "GEOX", status: ""},
    {img: SpringfieldLogo, brand: "SPRINGFIELD", status: ""},
    {img: HUGOLogo, brand: "HUGO", status: ""},
    {img: ReplayLogo, brand: "REPLAY", status: ""},
    {img: WomenSecretLogo, brand: "WOMEN SECRET", status: ""},
    {img: GuessLogo, brand: "GUESS", status: ""},
    {img: CarpisaLogo, brand: "CARPISA", status: ""},
    {img: BOSSLogo, brand: "BOSS", status: ""},
    {img: XYZLogo, brand: "XYZ", status: ""},
    {img: YamamayLogo, brand: "YAMAMAY", status: ""},
    {img: Tom_TailorLogo, brand: "TOM TAILOR", status: ""},
    {img: CalvinKleinJeansLogo, brand: "CALVIN KLEIN JEANS", status: ""},
    {img: CalvinKleinUnderwearLogo, brand: "CALVIN KLEIN UNDERWEAR", status: ""},
    {img: CelioLogo, brand: "CELIO", status: ""}]

const kidsBrandData1 = [{img: MANGOLogo, brand: "MANGO", status: ""},
    {img: TimberlandLogo, brand: "TIMBERLAND", status: ""},
    {img: GEXOLogo, brand: "GEOX", status: ""},
    {img: OkaidiLogo, brand: "OKAIDI", status: ""},
    {img: GuessLogo, brand: "GUESS", status: "Coming soon"},
    {img: CalvinKleinJeansLogo, brand: "CALVIN KLEIN JEANS", status: ""},
    {img: CalvinKleinUnderwearLogo, brand: "CALVIN KLEIN UNDERWEAR", status: ""},
]

const lifeBrandData1 = [{img: OzdilekLogo, brand: "OZDILEK", status: ""},
    {img: WomenSecretLogo, brand: "WOMEN SECRET", status: ""}]

const appendLinks = (brandArray, logos) => {
    return brandArray.map(item => {
        const found = logos.find(l => l.src === item.img);
        return {
            ...item,
            link: found ? found.link : null
        };
    });
};

const femaleBrandData = appendLinks(femaleBrandData1, logos);
const maleBrandData = appendLinks(maleBrandData1, logos);
const kidsBrandData = appendLinks(kidsBrandData1, logos);
const lifeBrandData = appendLinks(lifeBrandData1, logos);

export default function NavBar({
                                   onSearch = () => {
                                   }
                               }) {
    const [isNotificationOpen, setIsNotificationopen] = useState(false);
    const {id, catId, name} = useParams();
    const [toggle, setToggle] = useState(true);
    const categoryValue = useSelector(state => state?.category);
    const genderData = useSelector(state => state.category?.gender);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [navMenu, setNavMenu] = useState('')
    const [mobilePreviewGender, setMobilePreviewGender] = useState(null);
    const [vendroBrand, setVendroBrand] = useState([]);
    const wishlistItems = useSelector(state => state.cart?.wishlistItems);
    const location = useLocation();
    const didBootstrapCategoriesRef = useRef(false);
    const cartData = useSelector(state => state.cart?.cartItems);
    const allProduct = useSelector(state => state.productData?.allProduct)
    const productId = useSelector(state => state.productData?.cart)
    const totalCartPrice = useSelector(state => state.productData?.cart.totalPrice);
    const [hoverImg, setHoverImg] = useState("")
    const [loading, setLoading] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [searchBox, setSearchBox] = useState("");
    const [brandList, setBrandList] = useState([]);
    const [cartPanelOpen, setCartPanelOpen] = useState(false);
    const selectedCatId = catId;
    const auth = useSelector(state => state?.productData?.users);

    const removeFromCart = (item) => {
        const sku = item?.item_code;
        const uniqueId = item?.uniqueId;
        const filtered = (cartData || []).filter((it) => {
            if (uniqueId && it.uniqueId) return String(it.uniqueId) !== String(uniqueId);
            if (sku) return String(it.item_code) !== String(sku);
            return !(it._id === item?._id && it.size === item?.size);
        });
        dispatch(addToCart(filtered));
    };
    const mobileCartTotal = (Array.isArray(cartData) ? cartData : []).reduce(
        (acc, item) => acc + (parseFloat(item?.totalPrice) || 0),
        0
    );
    const effectiveMobileCartTotal = Number(
        typeof totalCartPrice === 'number' && !Number.isNaN(totalCartPrice)
            ? totalCartPrice
            : mobileCartTotal
    );

    const notificationBar = async () => {
        isNotificationOpen === true ? setIsNotificationopen(false) : setIsNotificationopen(true);
        if (isNotificationOpen === true) {
            console.log("SearchBox Active")
        } else {
            console.log("SearchBox False")
        }
    }
    const isActive = (name) => navMenu === name ? 'subnav-open' : ''

    const RemoveGender = async () => {
        window.scrollTo({ top: 0, left: 0 });
        window.setTimeout(() => window.scrollTo({ top: 0, left: 0 }), 0);
        const gender = null;
        await dispatch(GenderData(gender))
    }

    useEffect(() => {
        getVendorBrand();
    }, [])

    // When the mobile drawer is open, prevent homepage slider CTA buttons
    // from stacking above the menu by toggling a body class.
    useEffect(() => {
        const cls = 'mobile-menu-open';
        if (!toggle) document.body.classList.add(cls);
        else document.body.classList.remove(cls);
        return () => document.body.classList.remove(cls);
    }, [toggle]);

    // On the landing (gender not chosen yet), categories may be empty.
    // Bootstrap categories with "female" WITHOUT setting GenderData, so `/` stays on Intropage.
    useEffect(() => {
        const hasCategories = !!categoryValue?.categories?.categoryList?.length;
        if (hasCategories) return;
        if (didBootstrapCategoriesRef.current) return;
        didBootstrapCategoriesRef.current = true;
        dispatch(GetAllCategory({ genderBased: "female" }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, categoryValue?.categories?.categoryList?.length]);

    const allCart = [];
    productId?.forEach(crtdt => {
        const cartData = allProduct?.find(dt => dt?._id === crtdt?.productId)
        allCart.push(cartData)

    })

    if (cartData.length > 0) {
        var totalCartProduct = cartData.map(item => item.quantity).reduce((prev, next) => prev + next);
    }


    /* I njëjti rrjedh si `chooseGender` në Header.js (pa mbyllje/hapje të mobile drawer) */
    const applyGenderAndHome = async (gender) => {
        window.scrollTo({
            top: 0,
            left: 0,
        });
        await dispatch(GenderData(gender));
        const data = {genderBased: gender};
        await dispatch(GetAllCategory(data));
        setMobilePreviewGender(null);
        navigate("/" + gender);
    };

    // Mobile menu: preview gender by loading categories only (NO GenderData, NO navigation)
    const previewGenderCategories = async (gender) => {
        window.scrollTo({
            top: 0,
            left: 0,
        });
        const data = { genderBased: gender };
        await dispatch(GetAllCategory(data));
    };

    const handleMobileGenderPreview = async (gender) => {
        setMobilePreviewGender(gender);
        await previewGenderCategories(gender);
        // stay in the mobile menu and show the category lists
        setNavMenu('');
    };

    const chooseGender = async (gender) => {
        setToggle(!toggle);
        await applyGenderAndHome(gender);
    };

    const goToBrands = async () => {
        window.scrollTo({
            top: 0,
            left: 0,
        });
        await dispatch(GenderData("brand"));
        navigate("/brands");
    };

    const goToOutlet = () => {
        window.scrollTo({
            top: 0,
            left: 0,
        });
        navigate("/brands/fifty-fifty");
    };

    const renderCategories = (categories) => {
        let myCategories = [];
        var i = 0

        for (let category of categories) {
            myCategories.push(
                <li className="ruby-menu-mega item text-black" key={category.name}>
                    {
                        category.parentId ? <a href={`/${category.slug}?cid=${category._id}&type=${category.type}`} onClick={()=>{
                                window.scrollTo({
                                    top: 0,
                                    left: 0,
                                });
                            }}>
                                {category.name}
                            </a> :
                            category?.children?.length > 0 ?
                                <>
                                    {(category.name === "Shtëpi" ? <>
                                        <a href='/home'
                                           className={(genderData === "life" ? 'text-black sub-menu-active' : 'text-black')}
                                           onClick={(e) => {
                                               chooseGender("life")
                                               window.scrollTo({
                                                   top: 0,
                                                   left: 0,
                                               });
                                           }}>
                                            <span className="NavCat text-black px-1">{category.name}</span>
                                        </a>
                                    </> : <>
                                        <a className='text-black'>
                                            <span className="NavCat text-black px-1">{category.name}</span>
                                        </a>
                                    </>)}
                                </>
                                :
                                <>
                                    <Link to={`/${category.slug}/${category.unqId}`} onClick={()=>{
                                        window.scrollTo({
                                            top: 0,
                                            left: 0,
                                        });
                                    }}>
                                        <span className="px-1 text-black">a{category.name}</span>
                                    </Link>
                                </>

                    }
                    {i + 1 && category.children.length > 0 ? (
                        <div className='ruby-grid ruby-grid-lined'>
                            <div className="ruby-row  container mx-auto">
                                <div className='internal-nav'>
                                    <div className='ruby-col-12  '>
                                        <div className='nav-shop shop-by-product'>
                                            {category?.name === "Shtëpi" ? (
                                                <h3 className="!flex items-center !justify-between gap-6 w-full">
                                                    <span className="pr-4">Blej sipas produktit</span>
                                                    <a
                                                        href="/home"
                                                        className="shrink-0 text-right text-xs font-semibold uppercase tracking-wider text-gray-700 hover:text-black transition-colors"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            applyGenderAndHome("life");
                                                        }}
                                                    >
                                                        Shiko më shumë
                                                    </a>
                                                </h3>
                                            ) : (
                                                <h3><span>Blej sipas produktit</span></h3>
                                            )}
                                            <div className='top_nav_li'>
                                                <ul className='custom_items'>
                                                    {renderCategories(category.children)}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </li>
            );
        }
        return myCategories;
    }

    const renderChildCategories = (categories, isMain) => {
        let myCategories = [];
        var i = 0
        for (let category of categories) {
            myCategories.push(
                <li className="ruby-menu-mega item text-black" key={category.name}>
                    {
                        <Link
                            to={category.name === "Shtëpi" ? "/life" : (isMain ? "#" : `/${category.slug}/${(genderData ? genderData : "female")}`)}
                            {...(category.name === "Shtëpi" ? {
                                onClick: (e) => {
                                    e.preventDefault();
                                    applyGenderAndHome("life");
                                }
                            } : isMain ? {
                                onClick: (e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }
                            } : {
                                onClick: () => window.scrollTo({
                                    top: 0,
                                    left: 0,
                                })
                            })}
                        >
                            <span className="px-1 text-black">{category.name}</span>
                        </Link>
                    }
                    {category?.groupCategory?.length > 0 ? (
                        <div className="brand-menu__panel">
                            <p className="brand-menu__title">
                                <span>{category.name}</span>
                            </p>
                            <ul className="brand-menu__list">
                                {category.groupCategory.map((item) => (
                                    <li key={item._id || item.slug || item.name}>
                                        <Link
                                            to={`/${item.slug}/${genderData ? genderData : "female"}`}
                                            onClick={() => window.scrollTo({ top: 0, left: 0 })}
                                        >
                                            {item.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}
                </li>
            );
        }

        // Desktop main ruby-menu: always include "Brendet" as a dedicated entry
        if (isMain) {
            const hasBrands =
                (categories || []).some(
                    (c) => String(c?.name || '').toLowerCase() === 'brendet' || String(c?.name || '').toLowerCase() === 'brende'
                );
            if (!hasBrands) {
                myCategories.push(
                    <li className="ruby-menu-mega item text-black brand-menu" key="ruby-menu-brendet">
                        <Link
                            to="/brands"
                            onClick={(e) => {
                                e.preventDefault();
                                goToBrands();
                            }}
                        >
                            <span className="px-1 text-black">Brendet</span>
                        </Link>
                        <div className="brand-menu__panel">
                            <p className="brand-menu__title">Të gjitha brendet</p>
                            <ul className="brand-menu__list">
                                {brandList.map((brand) => {
                                    const slug = brand.slug || String(brand.brand || "").toLowerCase().replace(/\s+/g, "-");
                                    if (!slug) return null;
                                    return (
                                        <li key={brand._id || slug}>
                                            <Link to={`/brands/${slug}`}>{brand.brand}</Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </li>
                );
            }
            myCategories.push(
                <li className="ruby-menu-mega item text-black" key="ruby-menu-outlet">
                    <Link
                        to="/brands/fifty-fifty"
                        onClick={(e) => {
                            e.preventDefault();
                            goToOutlet();
                        }}
                    >
                        <span className="px-1 text-red-600">Outlet</span>
                    </Link>
                </li>
            );
        }

        return myCategories;
    }


    const getVendorBrand = async () => {
        const res = await axios.get("/getVendor")
        setVendroBrand(res.data)
    }

    useEffect(() => {
        let cancelled = false;
        axios.get("/getBrands")
            .then((res) => {
                if (!cancelled && Array.isArray(res.data)) setBrandList(res.data);
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, []);

    const handleSearch = async (txt) => {
        const q = String(txt || '').trim();
        if (!q || q.length < 2) {
            setSearchResults([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const effectiveGender = genderData || undefined;
            const data = {
                brands: [q.toUpperCase()],
                sort: "",
                sizes: [],
                gtPrice: null,
                ltPrice: null,
                catAndGender: effectiveGender,
                page: 0,
                per_page: 10,
                discount: "",
                discountNo: "",
                selectedGender: effectiveGender,
                selectedCat: [],
                newIn: false,
                selectionForYou: false
            };
            const res = await axios.post("/scrollbox", data);

            const root = res?.data?.data ? res.data.data : res?.data;
            const productsRaw =
                (Array.isArray(root) && root) ||
                root?.products ||
                root?.ProductData ||
                root?.data ||
                root?.datax ||
                [];
            const products = (Array.isArray(productsRaw) ? productsRaw : [])
                .filter((p) => p && typeof p === 'object' && !p.msg);
            // Same product can exist in multiple stores (e.g. Mango 053 + 054)
            const deduped = [];
            const seen = new Set();
            for (const p of products) {
                const key = p.externalId ?? p.item_code ?? p._id ?? p.id;
                if (key == null || seen.has(key)) continue;
                seen.add(key);
                deduped.push(p);
            }
            setSearchResults(deduped);
        } catch (err) {
            console.error("Search error:", err);
        }
        setLoading(false);
    };

    // Debounce must always call the latest handleSearch (avoid stale closures)
    const latestSearchHandlerRef = useRef(handleSearch);
    useEffect(() => {
        latestSearchHandlerRef.current = handleSearch;
    }, [handleSearch]);

    const debouncedSearch = useRef(
        debounce((value) => latestSearchHandlerRef.current(value), 500)
    ).current;

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    // onChange handler
    const handleInputChange = (value) => {
        setSearchBox(value)
        debouncedSearch(value)
    }

    useEffect(() => {
        setNavMenu('')
    }, [toggle]);

    const mobileGenderTabActive = mobilePreviewGender ?? genderData;
    return (

        <div className="ruby-menu-demo-header w-full">
            <div className="ruby-wrapper w-full justify-between items-center">
                <button onClick={() => setToggle(!toggle)} className="c-hamburger c-hamburger--htx visible-xs">
                    <span></span>
                </button>
                {/*<div>

                    <div className="LanguageSwitcher LanguageSwitcher--light hidden">
                        <button>English
                            <span className="LanguageSwitcher__icon" style={{ marginLeft: "8px" }}>
                                <svg width="14.395" height="14.395" viewBox="0 0 14.395 14.395">
                                    <path id="Icon_material-language" data-name="Icon material-language"
                                        d="M10.19,3a7.2,7.2,0,1,0,7.2,7.2A7.194,7.194,0,0,0,10.19,3Zm4.988,4.318H13.055a11.263,11.263,0,0,0-.993-2.562A5.779,5.779,0,0,1,15.178,7.318ZM10.2,4.468a10.139,10.139,0,0,1,1.375,2.85H8.823A10.139,10.139,0,0,1,10.2,4.468ZM4.627,11.637a5.63,5.63,0,0,1,0-2.879H7.059a11.887,11.887,0,0,0-.1,1.439,11.887,11.887,0,0,0,.1,1.439Zm.59,1.439H7.34a11.263,11.263,0,0,0,.993,2.562A5.748,5.748,0,0,1,5.217,13.076ZM7.34,7.318H5.217A5.748,5.748,0,0,1,8.333,4.756,11.263,11.263,0,0,0,7.34,7.318ZM10.2,15.926a10.139,10.139,0,0,1-1.375-2.85h2.749A10.139,10.139,0,0,1,10.2,15.926Zm1.684-4.29H8.513A10.589,10.589,0,0,1,8.4,10.2a10.5,10.5,0,0,1,.115-1.439h3.368A10.5,10.5,0,0,1,12,10.2,10.589,10.589,0,0,1,11.882,11.637Zm.18,4a11.263,11.263,0,0,0,.993-2.562h2.123A5.779,5.779,0,0,1,12.061,15.639Zm1.274-4a11.887,11.887,0,0,0,.1-1.439,11.887,11.887,0,0,0-.1-1.439h2.433a5.63,5.63,0,0,1,0,2.879Z"
                                        transform="translate(-3 -3)"></path>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>*/}

                <div
                    className={!toggle ? "MobileNavigationContent MobileNavigationContent--open block lg:hidden mobile-display mobile-new-navigation" : "MobileNavigationContent MobileNavigationContent--open block lg:hidden"}
                    style={{width: "100%"}}>
                    <div className="MobileNavigationContent__wrapper">
                        <div className="mobile-nav-tab">
                            <button className="close" onClick={() => setToggle(!toggle)}></button>
                            <div className="mobile-menu">
                                <ul className='headerlinks'>
                                    <li className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${mobileGenderTabActive === "female" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}
                                        onClick={() => handleMobileGenderPreview("female")}>FEMËR
                                    </li>
                                    <li className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${mobileGenderTabActive === "male" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}
                                        onClick={() => handleMobileGenderPreview("male")}>MASHKULL
                                    </li>
                                    <li className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${mobileGenderTabActive === "kids" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}
                                        onClick={() => handleMobileGenderPreview("kids")}>FËMIJË
                                    </li>
                                    {/* <li className={`cursor-pointer ${genderData === "unisex" ? "bg-gray-200" : ""}`} onClick={(e) => chooseGender("unisex")}>UNISEX</li> */}
                                    <a
                                        href="/brands"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setToggle(!toggle);
                                            goToBrands();
                                        }}
                                    >
                                        <li className={`cursor-pointer hover:black text-black font-semibold rounded-sm ${genderData === "brand" ? "bg-black text-white hover:bg-black" : "hover:bg-gray-300"}`}>BRENDET</li>
                                    </a>
                                    <a
                                        href="/brands/fifty-fifty"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setToggle(!toggle);
                                            goToOutlet();
                                        }}
                                    >
                                        <li className="cursor-pointer hover:black text-red-600 font-semibold rounded-sm hover:bg-gray-300">OUTLET</li>
                                    </a>
                                </ul>
                            </div>


                            <div className="tab-section-1">
                                <div className="tab-menu">
                                    {categoryValue?.categories?.categoryList?.map(categoryList => {
                                        return (
                                            <ul key={categoryList.name} className="tab-menu-list">
                                                <li name="main-menu" className={isActive(categoryList.name)}>
                                                    <button
                                                        onClick={() => {
                                                            // "Shtëpi" in mobile menu should go directly to Stephi (life) page
                                                            if (categoryList?.name === "Shtëpi") {
                                                                applyGenderAndHome("life");
                                                                setToggle(!toggle);
                                                                return;
                                                            }
                                                            setNavMenu(categoryList.name);
                                                        }}
                                                        className='main-menu-mobile'
                                                    >
                                                        {categoryList.name}
                                                        {categoryList?.name === "Shtëpi" ? null : (
                                                            <i className="arrow right"></i>
                                                        )}
                                                    </button>
                                                    <ul className="tab-sub-menu">
                                                        <h3 className="back-button" onClick={() => setNavMenu("")}>
                                                            <i className="arrow left"></i> Back</h3>
                                                        {(categoryList?.groupCategory || []).map(subcategoryItems => {
                                                            const effectiveGender = mobileGenderTabActive || 'female';
                                                            let path = '/' + subcategoryItems.slug + '/' + effectiveGender;
                                                            return <a
                                                                key={subcategoryItems.slug+'inner'}
                                                                href={path}
                                                                className={subcategoryItems.unqId == selectedCatId ? "selected-sub-menu" : ""}
                                                            >
                                                                {subcategoryItems?.children?.length > 0 ? "" :
                                                                    <span className="px-1">{subcategoryItems.name}</span>}
                                                            </a>
                                                        })}
                                                    </ul>

                                                </li>
                                            </ul>
                                        )
                                    })}
                                    {/* <ul>
                                        <li name="main-menu">
                                            <a href="javascript:void(0)" className='main-menu-mobile'>Brendet<i className="arrow right"></i>
                                                <ul className="tab-sub-menu">
                                                    <h3 className="back-button"><i className="arrow left"></i> Back</h3>
                                                    <>
                                                        {genderData === "female" &&
                                                            femaleBrandData?.map(dt => (
                                                                <li>
                                                                    <div className='xyz'>
                                                                        <a href={`/brands/${dt?.brand.toLowerCase()}/?gender=${genderData}`}>
                                                                            <p onMouseEnter={() => { setHoverImg(dt?.img) }}>{dt?.brand}</p>
                                                                        </a>
                                                                        <span>{dt?.status}</span>
                                                                    </div>
                                                                </li>
                                                            ))}

                                                        {genderData === "male" &&
                                                            maleBrandData?.map(dt => (
                                                                <li>

                                                                    <div className='xyz'>
                                                                        <a href={`/brands/${dt?.brand.toLowerCase()}/?gender=${genderData}`}>

                                                                            <p onMouseEnter={() => { setHoverImg(dt?.img) }}>{dt?.brand}</p>
                                                                        </a>
                                                                        <span>{dt?.status}</span>
                                                                    </div>

                                                                </li>
                                                            ))}

                                                        {genderData === "kids" &&
                                                            kidsBrandData?.map(dt => (
                                                                <li>

                                                                    <div className='xyz'>
                                                                        <a href={`/brands/${dt?.brand.toLowerCase()}/?gender=${genderData}`}>
                                                                            <p onMouseEnter={() => { setHoverImg(dt?.img) }}>{dt?.brand}</p>
                                                                        </a>
                                                                        <span>{dt?.status}</span>
                                                                    </div>

                                                                </li>
                                                            ))}

                                                        {genderData === "life" &&
                                                            lifeBrandData?.map(dt => (
                                                                <li>

                                                                    <div className='xyz'>
                                                                        <a href={`/brands/${dt?.brand.toLowerCase()}/?gender=${genderData}`}>
                                                                            <p onMouseEnter={() => { setHoverImg(dt?.img) }}>{dt?.brand}</p>
                                                                        </a>
                                                                        <span>{dt?.status}</span>
                                                                    </div>

                                                                </li>
                                                            ))}
                                                    </>
                                                </ul>
                                            </a>
                                        </li>
                                    </ul> */}
                                </div>
                                <div className="px-4 pt-3">
                                    <button
                                        type="button"
                                        className="w-full rounded-md border border-gray-200 bg-white py-2 text-xs font-semibold uppercase tracking-wider text-gray-700 hover:text-black hover:border-gray-300 transition-colors"
                                        onClick={() => {
                                            // redirect only (gender already set on preview click)
                                            const g = mobileGenderTabActive || "female";
                                            applyGenderAndHome(g); // this sets GenderData + navigates to /home
                                            setToggle(!toggle);
                                        }}
                                    >
                                        Shiko më shumë
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Link className='imglink mobilelogo block lg:hidden' to="/" onClick={RemoveGender}>
                    <img src={logonew} className="logo" alt="" srcSet=""/>
                </Link>
                <ul className="MobileHeaderTop__shop-nav block lg:hidden">

                    <div className="MobileHeaderSearch">
                        <button className="MobileHeaderSearch__icon" onClick={notificationBar}>
                            <img src="https://albionline.com/static/media/search-black.110c1cc7.svg" alt=""
                                 className="Image"/>
                        </button>
                    </div>

                    <li className="MobileHeaderTop__shop-nav__list" style={{marginTop: "8px"}}>
                        <button className="-ml-8" onClick={onSearch}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon icon-tabler icon-tabler-search"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                strokeWidth={2}
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"/>
                                <path d="M21 21l-6 -6"/>
                            </svg>
                        </button>
                    </li>

                    <li className="MobileHeaderTop__shop-nav__profile" style={{marginTop: "5px"}}>
                        {auth?.token && auth?.user ? <Link to="/profile" className="hidden md:block">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-tabler icon-tabler-search"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.6}
                                    stroke="currentColor"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/>
                                    <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/>
                                    <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"/>
                                </svg>
                            </Link> :
                            <Link to="/login" className="hidden md:block">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="icon icon-tabler icon-tabler-search"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.6}
                                    stroke="currentColor"
                                    fill="none"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/>
                                    <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/>
                                    <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"/>
                                </svg>
                            </Link>
                        }
                    </li>

                    <li className="MobileHeaderTop__shop-nav__list" style={{marginTop: "5px"}}>
                        <a href="/wishlist">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon icon-tabler icon-tabler-heart"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                strokeWidth={1.6}
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"/>
                            </svg>
                            {wishlistItems && wishlistItems.length > 0 ? <><span
                                className=" text-white w-1 h-1 flex justify-center items-center bg-red-500 rounded-full mobile-wishlist">{wishlistItems.length}</span></> : ''}
                        </a>
                    </li>

                    <li className="MobileHeaderTop__shop-nav__cart mobile-cart-nav" style={{marginTop: "5px"}}>
                        <button
                            type="button"
                            className="mobile-cart-trigger"
                            onClick={async () => {
                                if (location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')) {
                                    return;
                                }
                                await dispatch(getCartItems());
                                setCartPanelOpen(true);
                            }}
                            aria-label="Përmbajtja e shportës"
                            disabled={location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')}
                            aria-disabled={location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon icon-tabler icon-tabler-shopping-cart"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                strokeWidth={1.6}
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>
                                <path d="M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>
                                <path d="M17 17h-11v-14h-2"/>
                                <path d="M6 5l14 1l-1 7h-13"/>
                            </svg>
                            {cartData.length > 0 ? (
                                <span className="header-active text-white w-1 h-1 flex justify-center items-center bg-red-500 rounded-full mobile-cart">{totalCartProduct}</span>
                            ) : null}
                        </button>
                    </li>
                </ul>

                {/* Mobile cart panel - Përmbajtja e shportës (hidden on /cart and /checkout) */}
                {!(location.pathname.startsWith('/cart') || location.pathname.startsWith('/checkout')) && (
                    <>
                        <div
                            className={`mobile-cart-panel-overlay ${cartPanelOpen ? 'mobile-cart-panel-open' : ''}`}
                            onClick={() => setCartPanelOpen(false)}
                            aria-hidden={!cartPanelOpen}
                        />
                        <div className={`mobile-cart-panel ${cartPanelOpen ? 'mobile-cart-panel-visible' : ''}`}>
                            <div className="mobile-cart-panel__header">
                                <h2 className="mobile-cart-panel__title">Përmbajtja e shportës</h2>
                                <button
                                    type="button"
                                    className="mobile-cart-panel__close"
                                    onClick={() => setCartPanelOpen(false)}
                                    aria-label="Mbyll"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M18 6L6 18M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <div className="mobile-cart-panel__body">
                                {cartData.length > 0 ? (
                                    <>
                                        <ul className="mobile-cart-panel__list">
                                            {cartData.map((dtt, idx) => {
                                                const qty = dtt?.quantity || dtt?.qty || 1;
                                                const backendLineTotal =
                                                    typeof dtt?.totalPrice === 'number'
                                                        ? parseFloat(dtt.totalPrice) || 0
                                                        : NaN;
                                                const unitFromBackend =
                                                    qty > 0 && !Number.isNaN(backendLineTotal)
                                                        ? backendLineTotal / qty
                                                        : NaN;
                                                const fallbackUnit = parseFloat(
                                                    dtt?.sale_price > 0 ? dtt?.sale_price : dtt?.regular_price
                                                ) || 0;
                                                const price = !Number.isNaN(unitFromBackend)
                                                    ? unitFromBackend
                                                    : fallbackUnit;

                                                return (
                                                    <li
                                                        key={(dtt?.uniqueId || dtt?.item_code || dtt?.name || '') + (dtt?.size || '') + idx}
                                                        className="mobile-cart-panel__item"
                                                    >
                                                        <div className="mobile-cart-panel__item-img">
                                                            <img src={dtt?.images?.[0] || ''} alt="" />
                                                        </div>
                                                        <div className="mobile-cart-panel__item-details">
                                                            <p className="mobile-cart-panel__item-name">{dtt?.name}</p>
                                                            <p className="mobile-cart-panel__item-price">
                                                                {price.toFixed(2)} {process.env.REACT_APP_CURRENCY} × {qty}
                                                            </p>
                                                            <p className="mobile-cart-panel__item-size">Madhësia: {dtt?.size}</p>
                                                            <button
                                                                type="button"
                                                                className="mobile-cart-panel__item-remove"
                                                                onClick={() => removeFromCart(dtt)}
                                                            >
                                                                ×
                                                            </button>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                        <div className="mobile-cart-panel__summary">
                                            <div className="mobile-cart-panel__summary-row">
                                                <span>Vlera e porosisë</span>
                                                <span>{effectiveMobileCartTotal.toFixed(2)} {process.env.REACT_APP_CURRENCY}</span>
                                            </div>
                                            <div className="mobile-cart-panel__summary-row mobile-cart-panel__summary-row--total">
                                                <span>TOTAL</span>
                                                <span>{effectiveMobileCartTotal.toFixed(2)} {process.env.REACT_APP_CURRENCY}</span>
                                            </div>
                                        </div>
                                        <p className="mobile-cart-panel__vat">Përfshirë TVSH</p>
                                        <div className="mobile-cart-panel__actions">
                                            <Link
                                                to="/checkout"
                                                className="mobile-cart-panel__cta mobile-cart-panel__cta--primary"
                                                onClick={() => setCartPanelOpen(false)}
                                            >
                                                Checkout
                                            </Link>
                                            <Link
                                                to="/cart"
                                                className="mobile-cart-panel__cta mobile-cart-panel__cta--secondary"
                                                onClick={() => setCartPanelOpen(false)}
                                            >
                                                Shporta
                                            </Link>
                                        </div>
                                    </>
                                ) : (
                                    <div className="mobile-cart-panel__empty">
                                        <p>Shporta juaj është e zbrazët</p>
                                        <Link
                                            to="/home"
                                            className="mobile-cart-panel__cta"
                                            onClick={() => setCartPanelOpen(false)}
                                        >
                                            Vazhdo të blesh
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}

                <div className='Mobileheadermenu hidden-xs'></div>

                <div className='nav-search-bar'>
                    <ul className="ruby-menu">
                        {categoryValue?.categories?.categoryList?.length > 0 ?
                            renderChildCategories(categoryValue?.categories?.categoryList, true) : null
                        }
                    </ul>

                </div>

                <div className="relative hidden-xs">
                    <div
                        className={`sidebar w-full py-2 bg-white shadow-md fixed top-0 left-0 h-screen overflow-y-auto z-50 transition-transform duration-300 ${isNotificationOpen ? 'translate-x-0' : '-translate-x-full'}`}>
                        {/* Close Button */}
                        <div className="flex justify-end border-b border-gray-200 px-4">
                            <button onClick={notificationBar} className="p-2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                                          d="M6 18L18 6M6 6l12 12"/>
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div
                        className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity ${isNotificationOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                        onClick={notificationBar}
                    />
                </div>
            </div>
        </div>
    )
}